<template>
  <el-dialog
    :title="title"
    :visible.sync="showPage"
    :before-close="cancel"
    append-to-body
  >
    <el-form
      :model="inputForm"
      label-width="100px"
      :label-position="labelPosition"
    >
      <el-form-item label="渠道号">
        <el-input
          v-model.number="inputForm.channel"
          auto-complete="off"
        ></el-input>
      </el-form-item>
      <el-form-item label="渠道名称">
        <el-input
          v-model.number="inputForm.name"
          auto-complete="off"
        ></el-input>
      </el-form-item>
      <el-form-item label="域名">
        <el-input
          v-model="inputForm.domain"
          auto-complete="off"
        ></el-input>
      </el-form-item>
      <el-form-item label="排序">
        <el-input
          v-model.number="inputForm.sort"
          @blur="sortBlur"
          auto-complete="off"
          type="number"
        ></el-input>
      </el-form-item>
      <el-form-item label="开关">
        <el-switch
            v-model="inputForm.switch"
            active-color="#13ce66"
            inactive-color="#ff4949">
        </el-switch>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="cancel">取 消</el-button>
      <el-button type="primary" @click="submit">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import {channel_add, channel_edit} from "@/request/api.js"
export default {
  data() {
    return {
      labelPosition: "right",
       inputForm: {
           channel:'',
           name:'',
           sort:1,
           switch:true
       },
    };
  },
  props: {
    showPage: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    editorInfo:{
      type:Object,
      default:{}
    }
  },
  methods: {
    cancel() {
      this.$emit("update:showPage", false);
    },
    sortBlur(){
        this.inputForm.sort = this.inputForm.sort<=0 ? 1 : this.inputForm.sort
    },
    submit(){
        for (const key in this.inputForm) {
            if(key !== 'switch'){
                if(!this.inputForm[key]){
                    console.log('为空的key',key)
                    if(key == 'channel'){this.$message.warning('请输入渠道号');return}
                    if(key == 'name'){this.$message.warning('请输入渠道名称');return}
                    if(key == 'sort'){this.$message.warning('请输入渠道号');return}
                }
            }
        }
        // let obj = {
        //     action:'channel_edit_add',
        //     channel:this.inputForm.channel,
        //     name:this.inputForm.name,
        //     sort:this.inputForm.sort,
        //     switch:Number(this.inputForm.switch),
        // }
        let params = {...this.inputForm}
        params.switch=Number(this.inputForm.switch)
        if(this.title == '渠道编辑'){
          params.action = 'channel_edit'
          channel_edit(params).then((res)=>{
            if(res.status == 0){
                this.$message.success(res.detail)
                this.$parent.getChannelList()
                setInterval(()=>{
                    this.cancel()
                },200)
            }
          })
        }else{
          params.action = 'channel_add'
          channel_add(params).then((res)=>{
            if(res.status == 0){
                this.$message.success(res.detail)
                this.$parent.getChannelList()
                setInterval(()=>{
                    this.cancel()
                },200)
            }
          })
        }
    }
  },
  created(){
    if(JSON.stringify(this.editorInfo) != '{}'){
      this.inputForm = JSON.parse(JSON.stringify(this.editorInfo))
    }
  }
};
</script>

<style lang="less" scoped>
/deep/ .el-dialog {
  position: fixed;
  top: 50%;
  left: 50%;
  margin-top: 0 !important;
  transform: translate(-50%, -50%);
}
</style>